module.exports = __webpack_public_path__ + "media/images/lp/1/support3-sp-09b14198a24dfece509ce26073cd6eca.png";